
module.exports = {
    url(endPoint) {
        return `${process.env.API_URL}${endPoint}`
    }
}


// WEBPACK FOOTER //
// lib/kvs.js